<template>
    <div v-if="showNotice" class="notify-pmi">
        <p>
            If you are planning to fund your treatment through private medical insurance, please call our contact centre on <a :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a> and have your authorisation number from your insurance provider at the ready. 
            Please note that if you continue your booking on our website, you may not be able to claim it back. 
        </p>
    </div>
</template>

<script>
    export default {
        name: 'NotifyOfPMI',
        props: {
            phoneNumber: {
                type: String,
                default: () => process.env.VUE_APP_ASCENTI_PHONE || '0330 678 0850',
            },
        },

        computed: {
            showNotice() {
                return !process.env.VUE_APP_PARTNER_NAME;
            },
        },
    }
</script>

<style lang="scss" scoped>
.notify-pmi {
    @apply w-full bg-white border border-red rounded-lg px-6 py-4 my-4 text-blue text-base leading-relaxed;

    a {
        @apply font-semibold underline;
    }
}

</style>